import React from 'react';
import EditTags from './EditTags';
import TagsList from './TagsList';

const ContentTagging = ({ editing, ...props }) => {
  if (editing) {
    return <EditTags {...props} />;
  }
  return <TagsList {...props} />;
};

export default ContentTagging;
